import { render, staticRenderFns } from "./Togo.vue?vue&type=template&id=2f7b1809&scoped=true&"
import script from "./Togo.vue?vue&type=script&lang=js&"
export * from "./Togo.vue?vue&type=script&lang=js&"
import style0 from "./Togo.vue?vue&type=style&index=0&id=2f7b1809&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b1809",
  null
  
)

export default component.exports